import { render, staticRenderFns } from "./HeaderDays.vue?vue&type=template&id=31fb1d38&scoped=true&"
import script from "./HeaderDays.vue?vue&type=script&lang=js&"
export * from "./HeaderDays.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDays.vue?vue&type=style&index=0&id=31fb1d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fb1d38",
  null
  
)

export default component.exports